import React from 'react';
import styled from 'styled-components';
import { SETTINGS } from '../../constants';
// logic

const PortalContainer = ({ className }) => (
  <div className={className} id={SETTINGS.PORTAL_ID}></div>
);

export default styled(PortalContainer)`
  display: flex;
  flex-grow: 1;
`;
